import { commonQuotesService } from '@/services/quotes/common';
import type { GetQuotesParams } from '@/services/quotes/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

/** Opções da consulta de cotações — compartilhadas com `useQueries`. */
export function quotesQueryOptions(params: GetQuotesParams = {}) {
  return queryOptions({
    queryKey: ['quotes', params],
    queryFn: async () => {
      const response = await commonQuotesService.getQuotes(params);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar cotações');
      }

      return response.data;
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  });
}

export function useQuotes(params: GetQuotesParams = {}) {
  return useQuery(quotesQueryOptions(params));
}
